/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const CHECKER = token('color.blanket');

export const Image = styled.img({
  margin: `${gridSize() * 2}px 0`,
  border: '3px solid',
  borderRadius: '3px',
  maxWidth: '60%',
  backgroundSize: '20px 20px',
  backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0',
  /* Checkerboard background effect */
  backgroundImage: `linear-gradient(45deg, ${CHECKER} 25%, transparent 25%), linear-gradient(-45deg, ${CHECKER} 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ${CHECKER} 75%), linear-gradient(-45deg, white 75%, ${CHECKER} 75%)`,
});

export const Dimension = styled.span({
  '& + &::before': {
    content: "' | '",
    color: token('color.text'),
  },
});

export const DimensionKey = styled.strong({
  fontWeight: token('font.weight.bold'),
  color: token('color.text'),
});

export const ImageWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});
